module.exports = __webpack_public_path__ + "static/img/logo.53f131a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecshopx/logo.svg
// module id = 937
// module chunks = 30